import api from "api";

const user = {
    create: (payload) => {
        return api(false, true).post('/users', payload);
    },
    
    dataEnable: (payload) => {
        return api(false, true).post('/users/data-enable', payload);
    },

    me: () => {
        return api().get('/users/me')
    },

    // Perfil público (/u/{username}). Aberto; com login traz `relationship`
    // ({ is_me, is_following, follows_you, is_friend }) para o botão Seguir.
    publicProfile: (username) => {
        return api().get(`/users/username/${encodeURIComponent(username)}`)
    },

    // Próximos eventos em que a pessoa vai. Só amigos (ou ela mesma): 403 para o resto.
    publicProfileEvents: (id) => {
        return api().get(`/users/profile/${id}/events`)
    },
    
    update: (id, payload) => {
        return api().put(`/users/${id}`, payload);
    },

    changePassword: (currentPassword, newPassword) => {
        return api().put('/users/change-new-password', {
            "current_password": currentPassword, 
            "new_password": newPassword 
        })
    },
    
    delete: (id) => {
        return api().delete(`/users/${id}`);
    },

    favoritedEvents: (page = 1, perPage = 9) => {
        return api().get('/users/events/favorited', {
            params: { page, perPage }
        });
    },

    visitedEvents: (limit = 5) => {
        return api().get('/users/events/visited', {
            params: { limit }
        });
    },
};
 
export default user;  